import { useCallback, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { ChevronLeft, MoreVert } from "@mui/icons-material";
import axios from "axios";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import { ReactComponent as Edit } from "./../../assets/images/icons/Google SVGs/edit.svg";
import LocationOnIcon from "./../../assets/images/icons/Google SVGs/location_on.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";
import { ReactComponent as Delete } from "./../../assets/images/icons/Google SVGs/delete.svg";
import { ReactComponent as Close } from "./../../assets/images/icons/Google SVGs/cancel.svg";
import RemoveIcon from "./../../assets/images/icons/Google SVGs/remove(red).svg";
import AddIcon from "./../../assets/images/icons/Google SVGs/add.svg";
import SecretaryNotFound from "./../../assets/images/icons/Google SVGs/Secretary.svg";
import FloatLabelInput from "../../components/FloatLabelInput";

const depositOptions = [
  { value: "", label: "درصد بیعانه را انتخاب کنید", disabled: true },
  { value: "0", label: "0" },
  { value: "30", label: "30%" },
  { value: "50", label: "50%" },
  { value: "100", label: "100%" },
];

const PlaceCard = (props) => {

  const navigate = useNavigate();

  const [changeLater, setChangeLater] = useState({})

  const backToAddRemoveDepartmentsModal = useRef()

  const [loading, setLoading] = useState(false);

  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + (token ? token : tokenLocal) };

  const [headerTitle, setHeaderTitle] = useState("");

  const [assignedDepartments, setAssignedDepartments] = useState([]);

  const [remainingDepartments, setRemainingDepartments] = useState([]);

  const [department, setDepartment] = useState({});

  const [departmentSearch, setDepartmentSearch] = useState("");
  const [doctorSearch, setDoctorSearch] = useState("");
  const [secretarySearch, setSecretarySearch] = useState("");

  const [assignedDoctors, setAssignedDoctors] = useState([]);
  const [remainingDoctors, setRemainingDoctors] = useState([]);

  const [assignedSecretaries, setAssignedSecretaries] = useState([]);

  const [resultSecretary, setResultSecretary] = useState({
    first_name: null,
    last_name: null,
    mobile: null,
    file: null,
  });

  const [readDocSec, setReadDocSec] = useState(false);
  const [docOrnot, setDocOrNot] = useState(true);

  // modal inputs of department
  const [placeManagerModalFields, setPlaceManagerModalFields] = useState({ ...props })

  const {
    description,
    technical_phone,
    phone,
    biography,
    deposit_percentage,
    pazirex_patient_service_amount,
    pazirex_provider_service_amount,
    total_visit_amount,
    isUpdating,
    id
  } = placeManagerModalFields

  const placeManagerModalUpdater = useCallback(setPlaceManagerModalFields, []);

  const resetFormFields = () => {
    placeManagerModalUpdater({
      deposit_percentage: '',
      pazirex_patient_service_amount: '',
      pazirex_provider_service_amount: '',
      total_visit_amount: '',
      phone: '',
      technical_phone: '',
      biography: '',
      description: '',
      isUpdating: false
    })
  }

  const secretariesList = useMemo(() => {
    return assignedSecretaries?.filter(secretary => secretary.first_name?.includes(doctorSearch) || secretary.last_name?.includes(doctorSearch))
  }, [assignedSecretaries, doctorSearch])

  const getDoctorsAPI = () => {
    setLoading(true);
    axios
      .get(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getDoctorsForDepartmentPlace +
        props.id +
        `/all-doctors?department_id=${department.id}`,
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setAssignedDoctors(response.data.data.doctors_list);
          setRemainingDoctors(response.data.data.other_doctors);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getSecretariesAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getSecretariesForDepartmentPlace +
        props.id +
        "/secretaries",
        {
          department_id: department.id ? department.id : null,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setAssignedSecretaries(response.data.data.secretaries_list);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getDepartmentsAPI = () => {
    setLoading(true);
    axios
      .get(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getDepartmentsForPlace +
        props.id +
        "/departments",
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setAssignedDepartments(response.data.data.departments_list);
          setRemainingDepartments(response.data.data.other_departments);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const removeDepartmentAPI = (department) => {
    if (department.is_used == true) {
      toast.warning(
        `برای حذف دپارتمان ${department.title}، ابتدا پزشکان این دپارتمان را حذف کنید`
      );
    } else {
      setLoading(true);
      axios
        .post(
          serverConfig.server.url +
          apiConfig.api.deleteAPIs.deleteDepartmentPlace,
          {
            place_id: props.id,
            department_id: department.id,
          },
          {
            headers,
          }
        )
        .then((response) => {
          setLoading(false);
          if (response.data.status === "success") {
            toast.success(response.data.message);
            getDepartmentsAPI();
          } else {
            if (typeof response.data.errors === typeof "String") {
              toast.error(response.data.errors);
            } else {
              response.data.errors.forEach((element) => {
                toast.error(element);
              });
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Error making API call:", error);
        });
    }
  };

  const addDepartmentAPI = () => {

    setLoading(true);

    const newDepartmentData = {
      place_id: props.id,
      department_id: department.id,
      ...placeManagerModalFields,
      description: biography
    }
    delete newDepartmentData?.technical_phone

    axios
      .post(
        serverConfig.server.url + apiConfig.api.addAPIs.addDepartmentPlace,
        newDepartmentData,
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDepartmentsAPI();
          backToAddRemoveDepartmentsModal.current.click()
          resetFormFields()
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const updateDepartmentApi = () => {

    setLoading(true);

    axios
      .post(
        serverConfig.server.url + apiConfig.api.updateAPIs.updateDepartmentPlace,
        { ...placeManagerModalFields, place_id: props.id, department_id: placeManagerModalFields.id },
        { headers }
      )
      .then(response => {

        if (response.data.status === "success") {

          setAssignedDepartments(prev => prev.map(place => place.id === id ? { ...place, ...placeManagerModalFields } : place));

          toast.success(response.data.message);
          backToAddRemoveDepartmentsModal.current.click?.()
          resetFormFields()

        } else {

          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }

        }

      })
      .catch(error => toast.error("Error making API call:", error))
      .finally(() => setLoading(false))
  }

  const addDoctorToDepartmentPlaceAPI = () => {

    setLoading(true);

    axios
      .post(
        serverConfig.server.url + apiConfig.api.addAPIs.addDoctorsToDepartmentPlace,
        {
          ...changeLater?.place,
          ...placeManagerModalFields,
          department_id: department?.id,
          user_id: changeLater?.doctor?.id,
          place_id: props?.id,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDoctorsAPI();
          resetFormFields()
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const updateDoctorToDepartmentPlaceAPI = () => {

    setLoading(true);

    axios
      .post(
        serverConfig.server.url + apiConfig.api.updateAPIs.updateDoctorsToDepartmentPlace,
        {
          ...changeLater?.place,
          ...placeManagerModalFields,
          place_id: props?.id,
          user_id: changeLater?.doctor?.id,
          department_id: changeLater?.place?.id
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDoctorsAPI();
          resetFormFields()
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const addSecretaryToDepartmentPlaceAPI = (mobile, first_name, last_name) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.addAPIs.addDoctorsToDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          mobile: mobile ? mobile : null,
          first_name: first_name ? first_name : null,
          last_name: last_name ? last_name : null,
          role: "secretary",
        },

        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getSecretariesAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const removeSecretaryFromDepartmentPlaceAPI = (secretaryId) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.deleteAPIs.deleteDoctorFromDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          user_id: secretaryId,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getSecretariesAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const removeDoctorFromDepartmentPlaceAPI = (doctorID) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.deleteAPIs.deleteDoctorFromDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          user_id: doctorID,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDoctorsAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  useEffect(() => { // TODO: shit code, refactor later
    if (readDocSec) {
      setReadDocSec(false);
      docOrnot ? getDoctorsAPI() : getSecretariesAPI();
    }
  }, [readDocSec]);

  return (
    <div>
      <div className="card background-bootstrap-gray-100">
        <div className="card-body p-2 fs-14 fw-regular d-flex row bg-transparent">
          <div className="col">
            <div
              className="color-bootstrap-gray-700 text-decoration-none"
              type="button"
              onClick={() => {
                navigate(`/place?${"pl=" + props.id}`);
              }}
            >
              {props.title}
            </div>
            <div className="d-flex color-iso-gray-300 mt-2 fs-12">
              <img src={LocationOnIcon} width={20} alt="" />
              <span className="me-1">{props.city_title}</span>
              <span>
                {"("}
                {props.province_title}
                {")"}
              </span>
            </div>
          </div>
          <div className="col-auto d-flex align-items-center">
            {haveAccess(roles, "place_card_setting") && (
              <div className="dropdown me-1 color-bootstrap-gray-700">
                <IconButton
                  type="button"
                  id="dropdownMenuOffset"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  data-bs-offset="30,-45"
                >
                  <MoreVert />
                </IconButton>

                <ul
                  className="dropdown-menu fit-dropdown w-fit"
                  aria-labelledby="dropdownMenuOffset"
                >
                  {haveAccess(roles, "place_card_show") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(`/place?${"pl=" + props.id}`);
                      }}
                    >
                      <div className="color-bootstrap-gray-700 text-decoration-none fs-14 w-100 d-block">
                        مشاهده
                      </div>
                    </li>
                  )}
                  {haveAccess(roles, "place_card_edit") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(
                          `/place-store?${"pl=" + props.id + "&action=edit"}`
                        );
                      }}
                    >
                      <div className="color-bootstrap-gray-700 text-decoration-none fs-14 w-100 d-block">
                        ویرایش
                      </div>
                    </li>
                  )}

                  {haveAccess(roles, "place_card_departments") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={getDepartmentsAPI}
                      data-bs-toggle="modal"
                      data-bs-target={`#add-remove-departments-modal-${props.id}`}
                    >
                      مدیریت دپارتمان‌ها
                    </li>
                  )}

                  {haveAccess(roles, "place_card_secretaries") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        docOrnot && setDocOrNot(false);
                        getDepartmentsAPI();
                        setSecretarySearch("");
                        setResultSecretary({
                          mobile: null,
                          first_name: null,
                          last_name: null,
                        });
                      }}
                      data-bs-toggle="modal"
                      data-bs-target={`#select-departments-modal-${props.id}`}
                    >
                      مدیریت منشی‌ها
                    </li>
                  )}
                  {haveAccess(roles, "place_card_doctors") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        !docOrnot && setDocOrNot(true);
                        getDepartmentsAPI();
                      }}
                      data-bs-toggle="modal"
                      data-bs-target={`#select-departments-modal-${props.id}`}
                    >
                      مدیریت پزشکان
                    </li>
                  )}
                </ul>
              </div>
            )}

            {haveAccess(roles, "place_card_show_chevron") && (
              <IconButton
                onClick={() => {
                  navigate(`/place?${"pl=" + props.id}`);
                }}
              >
                <ChevronLeft />
              </IconButton>
            )}
          </div>
        </div>
      </div>

      {/* select department of place modal */}
      <div
        className="modal fade"
        id={`select-departments-modal-${props.id}`}
      >
        <div className="modal-dialog modal-dialog-scrollable">

          <div className="modal-content">

            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                placeholder="انتخاب دپارتمان ..."
                value={departmentSearch ?? ''}
                onChange={(e) => setDepartmentSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">

              {
                loading && (
                  <span
                    className="spinner-border spinner-border ms-1"
                    role="status"
                  />
                )
              }

              <div className="d-flex flex-column align-items-start gap-2">
                {assignedDepartments && assignedDepartments
                  .filter((e) => e.title.includes(departmentSearch))
                  .map((department, index) => (
                    <div
                      key={index}
                      className="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-10 mapItem tw-rounded-lg tw-overflow-hidden tw-pr-3 tw-p-2"
                      data-bs-toggle="modal"
                      data-bs-target={`${docOrnot ? "#add-remove-doctors-modal-" : "#add-remove-secretaries-modal-"}${props.id}`}
                      onClick={() => {
                        if (!docOrnot) {
                          setSecretarySearch("")
                          setResultSecretary({ mobile: null, first_name: null, last_name: null });
                        }
                        setHeaderTitle(department.title);
                        setDepartment({ ...department });
                        placeManagerModalUpdater({ ...department })
                        docOrnot ? setReadDocSec(true) : setReadDocSec(true);
                      }}
                    >
                      <button className="w-100 d-flex align-items-start !tw-text-[#495057] tw-border-none tw-bg-inherit tw-p-0">
                        <div className="d-flex col">{department.title}</div>
                      </button>
                      <img className="tw-flex-shrink-0 tw-size-6 tw-object-none" src="./chevron_left_dark.svg" alt="right arrow" />
                    </div>
                  ))}
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* add or remove doctors of department place modal */}
      <div
        className="modal fade"
        id={`add-remove-doctors-modal-${props.id}`}
      >
        <div className="modal-dialog modal-dialog-scrollable">

          <div className="modal-content">

            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-toggle="modal"
                data-bs-target={`#select-departments-modal-${props.id}`}
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                placeholder="جستجوی دکتر ..."
                value={doctorSearch ?? ''}
                onChange={(e) => setDoctorSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">

              {
                loading && (
                  <span
                    className="spinner-border spinner-border ms-1"
                    role="status"
                  />
                )
              }

              <div className="d-flex flex-column align-items-start gap-2">
                {assignedDoctors &&
                  assignedDoctors
                    .filter(
                      (doctor) =>
                        (doctor.title
                          ? doctor.title.includes(doctorSearch)
                          : "") ||
                        doctor.first_name.includes(doctorSearch) ||
                        doctor.last_name.includes(doctorSearch)
                    )
                    .map((doctor, index) => {
                      return (
                        <div
                          className="btn-group w-100 activeMapItem"
                          role="group"
                          aria-label="Basic mixed styles example"
                          key={index}
                          onClick={() => {
                            setChangeLater({ place: department, doctor })
                            placeManagerModalUpdater({ ...doctor, isUpdating: true })
                          }}
                          data-bs-toggle={'modal'}
                          data-bs-target={`#add_doctor_detail_modal_${id}`}
                        >
                          <button className="itemBtn tw-border-none tw-bg-inherit w-100 d-flex align-items-start my-2 tw-mr-2">
                            <div className="d-flex col">
                              {doctor.title ? doctor.title : ""}{" "}
                              {doctor.first_name} {doctor.last_name}
                            </div>
                          </button>
                          <Edit className="tw-flex-grow-1 tw-flex-shrink-0 tw-ml-3" />
                        </div>
                      );
                    })}
              </div>

              <div className="d-flex flex-column align-items-start gap-2 tw-mt-2">
                {remainingDoctors &&
                  remainingDoctors
                    .filter(
                      (doctor) =>
                        (doctor.title
                          ? doctor.title.includes(doctorSearch) : "") ||
                        doctor.first_name.includes(doctorSearch) ||
                        doctor.last_name.includes(doctorSearch)
                    )
                    .map((doctor, index) => (
                      <div
                        className="btn-group w-100 mapItem"
                        role="group"
                        aria-label="Basic mixed styles example"
                        key={index}
                        onClick={() => {
                          setChangeLater({
                            place: { ...props, phone: props.technical_phone },
                            doctor: { ...doctor }
                          })
                          placeManagerModalUpdater({
                            ...props,
                            phone: props.technical_phone,
                            isUpdating: false
                          })
                        }}
                        data-bs-toggle={'modal'}
                        data-bs-target={`#add_doctor_detail_modal_${id}`}
                      >
                        <button className="itemBtn tw-border-none tw-bg-inherit w-100 d-flex align-items-start my-2 tw-pr-3">
                          <div className="d-flex col">
                            {doctor.title ? doctor.title : ""}{" "}
                            {doctor.first_name} {doctor.last_name}
                          </div>
                        </button>
                        <img
                          className="btn my-2"
                          src={AddIcon}
                          width={53}
                          type="button"
                          alt="add doctor icon"
                        />
                      </div>
                    ))}
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* add or remove secretary of department place modal */}
      <div
        className="modal fade"
        id={`add-remove-secretaries-modal-${props.id}`}
      >
        <div className="modal-dialog modal-dialog-scrollable">

          <div className="modal-content border-radius-16">

            <div className="modal-header tw-flex tw-flex-col tw-gap-1 tw-items-start tw-w-full mx-0 py-2 color-bootstrap-gray-800 tw-border-none tw-relative">
              <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
                <span className="w-100 tw-text-[#212529] tw-text-[16px] tw-font-medium">اختصاص منشی</span>
                <Close
                  className="tw-size-6 tw-flex-grow tw-flex-shrink-0"
                  type="button"
                  data-bs-dismiss="modal"
                />
              </div>
              <span className="tw-absolute tw-h-px tw-inset-x-0 tw-bottom-0 border-bottom tw-m-auto !tw-w-[95%]"></span>
            </div>

            <p className="tw-text-sm tw-font-normal tw-text-[#495057] tw-p-3 tw-pb-0 tw-m-0">منشی‌های دپارتمان {headerTitle}</p>

            <div className="tw-pb-6 tw-pt-4 tw-px-3">

              {
                loading && <span className="spinner-border spinner-border ms-1 my-2" role="status" />
              }

              <div className="d-flex flex-column align-items-start tw-gap-2">
                {
                  secretariesList?.length
                    ?
                    secretariesList.map((secretary, index) => {
                      return (
                        <>
                          <div key={index} className="btn tw-flex tw-w-full tw-items-center tw-p-2 tw-rounded-lg tw-justify-between !tw-bg-[#F8F9FA] tw-border-[#DEE2E6]">
                            <div className="tw-flex tw-items-center tw-gap-2">
                              <img
                                className="secretary-image-box tw-size-[55px] tw-rounded-full tw-overflow-hidden object-fit-cover"
                                src={
                                  secretary.file
                                    ? secretary.file
                                    : SecretaryNotFound
                                }
                                alt="user"
                              />
                              <div className="tw-flex tw-flex-col tw-h-full tw-justify-center tw-gap-1">
                                <p className="tw-m-0 tw-text-[16px] tw-font-medium tw-text-[#343A40]">
                                  {secretary.first_name} {secretary.last_name}
                                </p>
                                <p className="tw-m-0 tw-text-sm tw-font-normal tw-text-[#6C757D]">
                                  {secretary.mobile}
                                </p>
                              </div>
                            </div>
                            <img
                              className="tw-size-6 tw-flex-shrink-0"
                              src={RemoveIcon}
                              alt="remove"
                              type="button"
                              onClick={() => {
                                removeSecretaryFromDepartmentPlaceAPI(secretary.id);
                              }}
                            />
                          </div>
                        </>
                      );
                    })
                    :
                    !loading && <p className="tw-m-0">منشی اختصاص داده نشده</p>
                }
              </div>

            </div>

            <div className="tw-flex tw-items-center tw-gap-2 tw-h-[72px] tw-relative tw-p-3">

              <span className="tw-absolute tw-top-0 tw-inset-x-0 tw-bg-[#ADB5BD] tw-h-[1px] tw-w-full down-menu-drop"></span>

              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target={`#add-secretary-modal-${props.id}`}
                onClick={() => {
                  setResultSecretary((prevState) => ({
                    ...prevState,
                    first_name: null,
                    last_name: null,
                  }));
                }}
              >
                ثبت نام منشی
              </button>

              <button
                className="btn tw-text-[#0360D9] tw-border-[#0360D9] w-100 d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target={`#select-departments-modal-${props.id}`}
              >
                بازگشت
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* sign up secretary to department place modal */}
      <div
        className="modal fade"
        id={`add-secretary-modal-${props.id}`}
      >
        <div className="modal-dialog modal-dialog-scrollable">

          <div className="modal-content border-radius-16">

            <div className="modal-header tw-flex tw-flex-col tw-gap-1 tw-items-start tw-w-full mx-0 tw-pl-2 py-2 color-bootstrap-gray-800 tw-border-none tw-relative">
              <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
                <span className="w-100 tw-text-[#212529] tw-text-[16px] tw-font-medium">اطلاعات دپارتمان {headerTitle}</span>
                <Close
                  className="tw-size-6 tw-flex-grow tw-flex-shrink-0"
                  type="button"
                  data-bs-dismiss="modal"
                />
              </div>
              <span className="tw-absolute tw-h-px tw-inset-x-0 tw-bottom-0 border-bottom tw-m-auto !tw-w-[95%]"></span>
              <p className="tw-text-sm tw-font-normal tw-text-[#495057] tw-m-0">اطلاعات منشی را با دقت وارد کنید</p>
            </div>

            <div className="modal-body tw-py-6 tw-px-3">

              <div className="d-flex col mb-3 col-12">
                <input
                  className="form-control"
                  type="tel"
                  placeholder="شماره تماس"
                  // value={secretarySearch}
                  value={resultSecretary?.mobile ?? ""}
                  onChange={(e) => {
                    setResultSecretary((prevState) => ({
                      ...prevState,
                      mobile: e.target.value,
                    }));
                  }}
                />
              </div>

              <div className="d-flex col mb-3 col-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام"
                  value={resultSecretary?.first_name ?? ""}
                  onChange={(e) => {
                    setResultSecretary((prevState) => ({
                      ...prevState,
                      first_name: e.target.value,
                    }));
                  }}
                />
              </div>

              <div className="d-flex col mb-3 col-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام خانوادگی"
                  value={resultSecretary?.last_name ?? ''}
                  onChange={(e) => {
                    setResultSecretary((prevState) => ({
                      ...prevState,
                      last_name: e.target.value,
                    }));
                  }}
                />
              </div>

            </div>

            <div className="tw-flex tw-items-center tw-gap-2 tw-h-[72px] tw-relative tw-p-3">

              <span className="tw-absolute tw-top-0 tw-inset-x-0 tw-bg-[#ADB5BD] tw-h-[1px] tw-w-full down-menu-drop"></span>

              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target={`#add-remove-secretaries-modal-${props.id}`}
                disabled={
                  !resultSecretary.mobile ||
                  resultSecretary.mobile.length != 11 ||
                  !resultSecretary.first_name ||
                  resultSecretary.first_name.length < 3 ||
                  !resultSecretary.last_name ||
                  resultSecretary.last_name.length < 3
                }
                onClick={() => {
                  addSecretaryToDepartmentPlaceAPI(
                    resultSecretary.mobile,
                    resultSecretary.first_name,
                    resultSecretary.last_name
                  );
                }}
              >
                ثبت نام منشی
              </button>

              <button
                className="btn tw-text-[#0360D9] tw-border-[#0360D9] w-100 d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target={`#add-remove-secretaries-modal-${props.id}`}
              >
                بازگشت
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* add or remove department of place modal */}
      <div
        className="modal fade"
        id={`add-remove-departments-modal-${props.id}`}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                placeholder="انتخاب دپارتمان ..."
                value={departmentSearch ?? ''}
                onChange={(e) => setDepartmentSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">

              {
                loading && (
                  <span
                    className="spinner-border spinner-border ms-1"
                    role="status"
                  />
                )
              }

              <div className="d-flex flex-column align-items-start gap-2 tw-mb-2">
                {assignedDepartments &&
                  assignedDepartments
                    .filter((department) => department.title.includes(departmentSearch))
                    .map((department, index) => {
                      return (
                        <div
                          className="btn-group w-100 activeMapItem"
                          role="group"
                          aria-label="Basic mixed styles example"
                          key={index}
                          data-bs-toggle="modal"
                          data-bs-target={`#detail-modal-${props.id}`}
                          onClick={() => {
                            placeManagerModalUpdater({ ...department, isUpdating: true })
                            setDepartment({ ...department });
                          }}
                        >
                          <button className="itemBtn tw-border-none tw-bg-inherit w-100 d-flex align-items-start my-2 tw-mr-2">
                            <div className="d-flex col">{department.title}</div>
                          </button>
                          <Edit className="tw-flex-grow-1 tw-flex-shrink-0 tw-ml-3" />
                        </div>
                      );
                    })}
              </div>

              <div className="d-flex flex-column align-items-start gap-2">
                {remainingDepartments &&
                  remainingDepartments
                    .filter((e) => e.title.includes(departmentSearch))
                    .map((department, index) => (
                      <div
                        className="btn-group w-100 mapItem"
                        role="group"
                        aria-label="Basic mixed styles example"
                        key={index}
                        data-bs-toggle="modal"
                        data-bs-target={`#detail-modal-${props.id}`}
                        onClick={() => {
                          placeManagerModalUpdater({
                            description: '',
                            ...props,
                            phone: props.technical_phone,
                            isUpdating: false
                          })
                          setDepartment({ ...department });
                        }}
                      >
                        <button className="itemBtn tw-border-none tw-bg-inherit w-100 d-flex align-items-start my-2 tw-mx-3">
                          <div className="d-flex col">{department.title}</div>
                        </button>

                        <img
                          className="itemBtn my-2 tw-ml-2"
                          alt="light btn"
                          src={AddIcon}
                          width={24}
                          type="button"
                        // data-bs-toggle="modal"
                        // data-bs-target={`#detail-modal-${props.id}`}
                        // onClick={() => {
                        //   placeManagerModalUpdater(prev => ({ ...prev, biography: department.biography ? department.biography : '' }))
                        //   setDepartment({ ...department });
                        // }}
                        />
                      </div>
                    ))}
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* add detail of added department modal */}
      <div
        className="modal fade"
        id={`detail-modal-${props.id}`}
      >
        <div className="modal-dialog modal-dialog-scrollable">

          <div className="modal-content tw-p-0">

            <div className="modal-header tw-flex tw-flex-col tw-gap-1 tw-items-start tw-border-none tw-w-full mx-0 tw-pl-2 py-2 color-bootstrap-gray-800 tw-relative">
              <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
                <span className="w-100 tw-text-[#212529] tw-text-[16px] tw-font-medium">اطلاعات دپارتمان {headerTitle}</span>
                <Close
                  className="tw-size-6 tw-flex-grow tw-flex-shrink-0"
                  type="button"
                  data-bs-dismiss="modal"
                />
              </div>
              <span className="tw-absolute tw-h-px tw-inset-x-0 tw-bottom-0 border-bottom tw-m-auto !tw-w-[95%]"></span>
              <p className="tw-text-sm tw-font-normal tw-text-[#495057] tw-m-0">{department.title}</p>
            </div>

            <div className="tw-flex tw-flex-col tw-gap-3 tw-px-3 tw-py-6">

              <FloatLabelInput
                title={"شماره موبایل"}
                fieldKey={'phone'}
                onUpdate={placeManagerModalUpdater}
                value={phone ?? ''}
              />

              <FloatLabelInput
                title={"توضیحات دپارتمان (اختیاری)"}
                fieldKey={'biography'}
                onUpdate={placeManagerModalUpdater}
                value={biography ?? ''}
              />

              <div className="d-flex col col-12">
                <select
                  className="form-select"
                  aria-label="درصد بیعانه"
                  value={deposit_percentage ?? ''}
                  onChange={e => placeManagerModalUpdater(prev => ({ ...prev, deposit_percentage: e.target.value }))}
                >
                  {
                    depositOptions.map(option => (
                      <option
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                      >
                        {option.label}
                      </option>
                    ))
                  }
                </select>
              </div>

              <FloatLabelInput
                title={"هزینه خدمات پذیرکس برای بیمار"}
                fieldKey="pazirex_patient_service_amount"
                onUpdate={placeManagerModalUpdater}
                value={pazirex_patient_service_amount ?? ''}
              />

              <FloatLabelInput
                title={"هزینه خدمات پذیرکس برای پزشک"}
                fieldKey="pazirex_provider_service_amount"
                onUpdate={placeManagerModalUpdater}
                value={pazirex_provider_service_amount ?? ''}
              />

              <FloatLabelInput
                title={"هزینه کل ویزیت"}
                fieldKey="total_visit_amount"
                onUpdate={placeManagerModalUpdater}
                value={total_visit_amount ?? ''}
              />

            </div>

            <div className="tw-flex tw-items-center tw-gap-2 tw-h-[72px] tw-relative tw-p-3">

              <span className="tw-absolute tw-top-0 tw-inset-x-0 tw-bg-[#ADB5BD] tw-h-[1px] tw-w-full down-menu-drop"></span>

              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                disabled={loading}
                onClick={isUpdating ? updateDepartmentApi : addDepartmentAPI}
              >
                {isUpdating ? 'بروزرسانی' : 'ثبت'}
              </button>

              <button
                className="btn tw-text-[#0360D9] tw-border-[#0360D9] w-100 d-flex align-items-center justify-content-center"
                ref={backToAddRemoveDepartmentsModal}
                data-bs-toggle="modal"
                data-bs-target={`#add-remove-departments-modal-${props.id}`}
                aria-label="Close"
              >
                بازگشت
              </button>

              {
                isUpdating && (
                  <div
                    data-bs-toggle="modal"
                    data-bs-target={`#add-remove-departments-modal-${props.id}`}
                    onClick={() => removeDepartmentAPI(department)}
                    className="btn tw-size-10 tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-justify-center tw-border-[#F83234] tw-flex-grow tw-flex-shrink-0"
                  >
                    <Delete className="tw-text-red-500" />
                  </div>
                )
              }

            </div>

          </div>

        </div>

      </div >

      {/*  detail of added doctor */}
      <div div
        className="modal fade"
        id={`add_doctor_detail_modal_${id}`}
        tabIndex="-1"
        aria-labelledby={`add_doctor_detail_modal_${id}`}
      >
        <div className="modal-dialog modal-dialog-scrollable">

          <div className="modal-content">

            <div className="modal-header tw-flex tw-flex-col tw-gap-1 tw-items-start tw-w-full mx-0 tw-pl-2 py-2 color-bootstrap-gray-800 tw-border-none tw-relative">
              <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
                <span className="w-100 tw-text-[#212529] tw-text-[16px] tw-font-medium">اطلاعات دپارتمان</span>
                <Close
                  className="tw-size-6 tw-flex-grow tw-flex-shrink-0"
                  type="button"
                  data-bs-dismiss="modal"
                />
              </div>
              <span className="tw-absolute tw-h-px tw-inset-x-0 tw-bottom-0 border-bottom tw-m-auto !tw-w-[95%]"></span>
              <p className="tw-text-sm tw-font-normal tw-text-[#495057] tw-m-0">{department.title ?? headerTitle}</p>
            </div>

            <div className="tw-flex tw-flex-col tw-gap-3 tw-px-3 tw-py-6">

              <FloatLabelInput
                title={"شماره موبایل"}
                fieldKey="phone"
                onUpdate={placeManagerModalUpdater}
                value={phone ?? ''}
              />

              <FloatLabelInput
                title={"توضیحات دپارتمان (اختیاری)"}
                fieldKey="description"
                onUpdate={placeManagerModalUpdater}
                value={description ?? ''}
              />

              <div className="d-flex col my-2 col-12">
                <select
                  className="form-select"
                  aria-label="درصد بیعانه"
                  value={deposit_percentage ?? ''}
                  onChange={e => placeManagerModalUpdater(prev => ({ ...prev, 'deposit_percentage': e.target.value }))}
                >
                  {
                    depositOptions.map(option => (
                      <option
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                      >
                        {option.label}
                      </option>
                    ))
                  }
                </select>
              </div>

              <FloatLabelInput
                title={"هزینه خدمات پذیرکس برای بیمار"}
                fieldKey="pazirex_patient_service_amount"
                onUpdate={placeManagerModalUpdater}
                value={pazirex_patient_service_amount ?? ''}
              />

              <FloatLabelInput
                title={"هزینه خدمات پذیرکس برای پزشک"}
                fieldKey="pazirex_provider_service_amount"
                onUpdate={placeManagerModalUpdater}
                value={pazirex_provider_service_amount ?? ''}
              />

              <FloatLabelInput
                title={"هزینه کل ویزیت"}
                fieldKey="total_visit_amount"
                onUpdate={placeManagerModalUpdater}
                value={total_visit_amount ?? ''}
              />

            </div>

            <div className="tw-flex tw-items-center tw-gap-2 tw-h-[72px] tw-relative tw-p-3">

              <span className="tw-absolute tw-top-0 tw-inset-x-0 tw-bg-[#ADB5BD] tw-h-[1px] tw-w-full down-menu-drop"></span>

              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target={`#add_doctor_detail_modal_${id}`}
                onClick={isUpdating ? updateDoctorToDepartmentPlaceAPI : addDoctorToDepartmentPlaceAPI}
              >
                {isUpdating ? 'بروزرسانی' : 'ثبت'}
              </button>

              <button
                className="btn tw-text-[#0360D9] tw-border-[#0360D9] w-100 d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target={`#add-remove-doctors-modal-${props.id}`}
              >
                بازگشت
              </button>

              {
                isUpdating && (
                  <div
                    data-bs-toggle="modal"
                    data-bs-target={`#add_doctor_detail_modal_${id}`}
                    onClick={() => removeDoctorFromDepartmentPlaceAPI(id)}
                    className="btn tw-size-10 tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-justify-center tw-border-[#F83234] tw-flex-grow tw-flex-shrink-0"
                  >
                    <Delete className="tw-text-red-500" />
                  </div>
                )
              }

            </div>

          </div>
        </div>
      </div >

    </div >
  );
};

export default PlaceCard;
